<!--
#########################################################################################
######################           Vista SVC40000  :  RECUENTOS           #################
#########################################################################################
-->
<template>
  <div style="height:100%">
      <!-- Top Navigation (Genérico) -->
      <TNC10000></TNC10000>

      <!-- Rangos -->
      <div class="row igs-back-color8">
              <div class="col-md-2 igs-back-color8 igs-center">
                <date-range-picker
                              ref="dp_RangoFechasDetalleMovimientos"
                              opens="right"
                              :append-to-body=true
                              :single-date-picker=false
                              :locale-data="dp1_localeData"
                              minDate="2023-01-01" maxDate="2035-12-31"
                              :timePicker=false
                              :timePicker24Hour=true
                              :showWeekNumbers=true
                              :showDropdowns=true
                              :autoApply=true
                              :ranges="dp1_defaultRanges"
                              :linkedCalendars=false
                              control-container-class="igs-btn-dh-fecha"
                              v-model="dp1_dateRange"
                              @update="lp30RangoFechasDetalleMovimientos"
                              >
                            <template v-slot:input="picker">
                              <div class="igs-color1 igs-l4 igs-mt-5 igs-center">
                                <b>{{ picker.startDate | lf60FiltroFecha }} <br/>a<br/> {{ picker.endDate | lf60FiltroFecha }}</b>
                              </div>
                            </template>
                </date-range-picker>
              </div>
              <div class="col-md-3 igs-center">
                <div class="igs-center igs-back-color2 igs-color0">Artículos</div>
                <div class="row igs-mt-5">
                  <div class="col-md-3 igs-l3 igs-mt-5 igs-left">&nbsp;&nbsp;<input class="igs-radio-back-color7" type="radio" value="0" v-model="ltFiltroDiferencias" @change="lp60CambioTareaRecuento()"/>&nbsp;Todos</div>
                  <div class="col-md-5 igs-l3 igs-mt-5 igs-left"><input class="igs-radio-back-color7" type="radio" value="1" v-model="ltFiltroDiferencias" @change="lp60CambioTareaRecuento()"/>&nbsp;Con Diferencias</div>
                  <div class="col-md-4 igs-l3 igs-mt-5 igs-left"><input class="igs-radio-back-color7" type="radio" value="2" v-model="ltFiltroDiferencias" @change="lp60CambioTareaRecuento()"/>&nbsp;Sin Diferencias</div>                        
                </div>
              </div>
              <div class="col-md-3 igs-center">
                <div class="igs-center igs-back-color4 igs-color0">Ubicaciones</div>
                <div class="row igs-mt-5">
                  <div class="col-md-3 igs-l3 igs-mt-5 igs-left">&nbsp;&nbsp;<input class="igs-radio-back-color7" type="radio" value="0" v-model="ltFiltroRecuento" @change="lp60CambioTareaRecuento()"/>&nbsp;Todas</div>
                  <div class="col-md-5 igs-l3 igs-mt-5 igs-left"><input class="igs-radio-back-color7" type="radio" value="1" v-model="ltFiltroRecuento" @change="lp60CambioTareaRecuento()"/>&nbsp;Recontadas</div>
                  <div class="col-md-4 igs-l3 igs-mt-5 igs-left"><input class="igs-radio-back-color7" type="radio" value="2" v-model="ltFiltroRecuento" @change="lp60CambioTareaRecuento()"/>&nbsp;Sin Recontar</div>                        
                </div>
                <div class="row igs-mt-5">
                  <div class="col-md-3 igs-l3 igs-mt-5 igs-left">&nbsp;&nbsp;<input class="igs-radio-back-color7" type="radio" value="0" v-model="ltFiltroOcupacion" @change="lp60CambioTareaRecuento()"/>&nbsp;Todas</div>
                  <div class="col-md-5 igs-l3 igs-mt-5 igs-left"><input class="igs-radio-back-color7" type="radio" value="1" v-model="ltFiltroOcupacion" @change="lp60CambioTareaRecuento()"/>&nbsp;Ocupadas</div>
                  <div class="col-md-4 igs-l3 igs-mt-5 igs-left"><input class="igs-radio-back-color7" type="radio" value="2" v-model="ltFiltroOcupacion" @change="lp60CambioTareaRecuento()"/>&nbsp;Libres</div>                        
                </div>
              </div>
              <div class="col-md-4">
                <div class="igs-center igs-back-color7 igs-color0">Información Adicional</div>
              </div>
      </div>

      <div style="height:80vh">

        <div class="row">
          <!--------------------------------->
          <!-- Lista de Tareas de Recuento -->
          <!--------------------------------->
          <div class="col-md-2 igs-l-pad-20 igs-left">
                <div class="row igs-back-color7 igs-color0 igs-center">
                  <span class="col-md-12 igs-center">Herramientas</span>
                </div>
                <div>
                  <span class="igs-color1 igs-fs-12 igs-pad-4" @click="lp60CrearNuevaTareaRecuento()">&nbsp;<Fa :icon="faPlusSquare" /> Nueva Tarea</span>&nbsp;&nbsp;
                  <span class="igs-color1 igs-fs-12 igs-pad-4" @click="lp98BorrarTareaRecuento()" v-if="ltTareaRecuentoSeleccionada != ''">&nbsp;<Fa :icon="faTrash" /> Borrar Tarea</span>
                </div>
                <div class="row igs-back-color7 igs-color0 igs-center igs-mt-8">
                  <span class="col-md-9 igs-center">Lista de Tareas</span>
                  <span class="col-md-3 igs-right fa fa-refresh igs-mt-2" aria-hidden="true" @click="lp98LeerTareasRecuentoDisponibles()">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
                </div>
                <div class="igs-center">
                  <select v-model="ltTareaRecuentoSeleccionada" @change="lp60CambioTareaRecuento()" class="igs-fs-14 " size="24" style="border:0px;outline:0px;height:72vh;">
                      <option v-for="item in laTareasRecuentoDisponibles" :key="item.tcl0" :value="item.tcl0"><span v-html="lf95EstadoTarea(item.t991)"></span>&nbsp;&nbsp;{{ f70AMD2fDMA(item.t036) }}&nbsp;&nbsp;{{ item.t012 }}&nbsp;&nbsp;{{ lf90DesinenciaRCB(item.t001) }} &nbsp;&nbsp;&nbsp;&nbsp;</option>
                  </select>              
                </div>
          </div>

          <div class="col-md-10">

            <!-- HUD -->
            <div class="row">
              <div class="col-12 igs-ancho-100 igs-center" v-if="lbCargando">  
                <br/><br/>
                <h2 class="igs-color2">Buscando resultados ....</h2>
                <br/><br/>
                <vue-ellipse-progress :loading="true" />
              </div>
            </div>

            <!-- Resultados -->
            <div class="row igs-back-color8"  v-if="!lbCargando">
                  <div class="col-md-12" v-if="ltFechaRecuentoTareaActual != '00000000'"><hr/></div>
                  <div class="col-md-3 igs-center" v-if="ltFechaRecuentoTareaActual != '00000000'">
                    <span class="igs-color7">Tarea  </span>
                    <span class="igs-bold">{{ f70AMD2fDMA(ltFechaRecuentoTareaActual) }} - </span>
                    <span class="igs-bold">{{ ltDescripcionTareaActual }}</span>

                    <!-- <span v-if="ltFechaCierreTareaActual == '00000000'" class="igs-l4 igs-bold igs-color8" @click="lp98CerrarTareaRecuentoActiva()" ><br/><Fa :icon="faClipboardCheck" /> Cerrar Recuento</span>   -->
                    <button class="igs-btn-primary igs-l2" style="position:relative; top:-5px;" @click="lp98CerrarTareaRecuentoActiva()" v-if="ltFechaCierreTareaActual == '00000000'"><Fa :icon="faClipboardCheck" /> Cerrar Recuento</button>

                    <span v-if="ltFechaCierreTareaActual != '00000000'" class="igs-l4 igs-bold igs-color9"><br/><Fa :icon="faCheck" /> Recuento Cerrado</span>                       
                  </div>
                  <div class="col-md-9 igs-l3 igs-mt-5" v-if="ltFechaRecuentoTareaActual != '00000000'">
                    <div class="row">
                      <div class="col-md-3 igs-center">
                        <span class="igs-color7">Creada&nbsp;&nbsp;</span>
                        <span class="igs-bold">{{ f70AMD2fDMA(ltFechaCreacionTareaActual) }} {{ f70HMS2fHMS(ltHoraCreacionTareaActual) }}<br/>({{ltUsuarioCreacionTareaActual}})</span>
                      </div>
                      <div class="col-md-3 igs-center">
                        <span class="igs-color7" v-if="ltFechaCierreTareaActual != '00000000'">Cerrada&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span class="igs-bold"   v-if="ltFechaCierreTareaActual != '00000000'">{{ f70AMD2fDMA(ltFechaCierreTareaActual) }} {{ f70HMS2fHMS(ltHoraCierreTareaActual) }}<br/>({{ltUsuarioCierreTareaActual}})</span>
                        <span class="igs-color8" v-if="ltFechaCierreTareaActual == '00000000'">Tarea de Recuento<br/><b>ABIERTA</b></span>

                      </div>
                      <div class="col-md-6 igs-center igs-pad-0">
                        <nobr>
                          <span>Artículos&nbsp;<b>{{f91Porcentaje(lf91ArticulosMostrados/lf91ArticulosRecibidos*100)}}%</b><span class="igs-l2">&nbsp;({{lf91ArticulosMostrados}}/{{ lf91ArticulosRecibidos }})</span></span>&nbsp;&nbsp;&nbsp;
                          <span>Huecos&nbsp;<b>{{f91Porcentaje(lf91UbicacionesMostradas/lf91UbicacionesRecibidas*100)}}%</b><span class="igs-l2">&nbsp;({{lf91UbicacionesMostradas}}/{{lf91UbicacionesRecibidas}})</span></span>&nbsp;&nbsp;&nbsp;
                          <span>Cantidades&nbsp;<b>{{f91Porcentaje(lf91SumaDiferencias/lf91SumaCantidades*100)}}%</b><span class="igs-l2">&nbsp;({{f91Cantidad(lf91SumaDiferencias)}}/{{f91Cantidad(lf91SumaCantidades)}})</span></span>
                        </nobr>
                      </div>
                    </div>

                  </div>
            </div>

            <div style="height:73vh;overflow-x:auto; overflow-y:scroll;">
              <table ref="Tabla400" v-if="!lbCargando" class="igs-ancho-100">
                  <thead style="position:sticky;top:0;">
                    <tr class="igs-l2 igs-back-color2 igs-color0 igs-pad-0">
                      <th scope="col" colspan="4">&nbsp;</th>
                      <th scope="col" colspan="2" class="igs-back-color1">Mapa</th>
                      <th scope="col" colspan="2" class="igs-back-color7">Recuento</th>
                      <th scope="col" colspan="2" class="igs-back-color3">Diferencia</th>
                      <th scope="col">Otros</th>
                    </tr>
                    <tr class="igs-l2 igs-back-color2 igs-color0">
                      <th scope="col" @click="lp50Sort(0)">Ubicación<span  v-html="lf91ColumnaOrden(0)" /></th>
                      <th scope="col" @click="lp50Sort(1)" >Artículo<span  v-html="lf91ColumnaOrden(1)" /></th>
                      <th scope="col" @click="lp50Sort(2)">Lote<span  v-html="lf91ColumnaOrden(2)" /></th>
                      <th scope="col" @click="lp50Sort(3)">Caducidad<span  v-html="lf91ColumnaOrden(3)" /></th>
                      <th scope="col" @click="lp50Sort(4)" class="igs-back-color1">Cantidad<span  v-html="lf91ColumnaOrden(4)" /></th>
                      <th scope="col" @click="lp50Sort(5)" class="igs-back-color1">Unidades<span  v-html="lf91ColumnaOrden(5)" /></th>
                      <th scope="col" @click="lp50Sort(6)" class="igs-back-color7">Cantidad<span  v-html="lf91ColumnaOrden(6)" /></th>
                      <th scope="col" @click="lp50Sort(7)" class="igs-back-color7">Unidades<span  v-html="lf91ColumnaOrden(7)" /></th>
                      <th scope="col" @click="lp50Sort(8)" class="igs-back-color3">Cantidad<span  v-html="lf91ColumnaOrden(8)" /></th>
                      <th scope="col" @click="lp50Sort(9)" class="igs-back-color3">Unidades<span  v-html="lf91ColumnaOrden(9)" /></th>
                      <th scope="col" @click="lp50Sort(10)">Datos<span  v-html="lf91ColumnaOrden(10)" /></th>
                    </tr>
                  </thead>
                  <tbody>
                      <!-- Lista de Resultados -->
                      <tr v-for="(tra, index) in lf50ListaRegistrosTRA" :key="index" class="igs-l3">
                        <td class="igs-l2"><span  v-html="f93MaquetarUbicacion(tra.t081,5)"></span></td>
                        <td class="igs-left">{{ tra.t002 }} - {{ tra.a002 }}</td>
                        <td>{{ tra.t003 }}</td>
                        <td>{{ lf91FechaCaducidad(tra.t031) }}</td>
                        <td>{{ f91Cantidad(tra.t511) }}</td>
                        <td>{{ tra.t512 }}</td>
                        <td>{{ f91Cantidad(tra.t521) }}</td>
                        <td>{{ tra.t522 }}</td>
                        <td :class="lf91ClaseDiferencia(tra.t531,tra.t532)">{{ f91Cantidad(tra.t531) }}</td>
                        <td :class="lf91ClaseDiferencia(tra.t531,tra.t532)">{{ tra.t532 }}</td>
                        <td class="igs-l2">
                          &nbsp;
                        </td>
                      </tr>
                  </tbody>
              </table>          
            </div>
          </div>
        </div>

      </div>


      <BNC10000></BNC10000>

      <!-- Ventana Modal .1. (Edición RCB) -->
      <VModal name="VMLeyenda1" height="auto" :minWidth=600 width="60%" @before-close="lp99OcultandoLeyenda1()" :draggable="true" :adaptive="true" :resizable="true">
        <div class="igs-back-color8" style="height:100%;">
          <div class="row">
            <div class="col-md-8 igs-back-color2"><h6 class="igs-color0 igs-center igs-pad-2 igs-bold">Creación de Nueva Tarea de Recuento</h6></div>
            <div class="col-md-2 igs-color0 igs-back-color2 igs-fs-12 igs-pad-4" @click="lp98CrearNuevaTareaRecuento()">&nbsp;&nbsp;<Fa :icon="faSave" /> Guardar</div>              
            <div class="col-md-2 igs-color0 igs-back-color2 igs-l3" @click="$modal.hide('VMLeyenda1')"><Fa :icon="faWindowClose" /></div>
          </div>

          <div class="row">
            <div class="col-md-8"></div>
            <div class="col-md-4 igs-fs-11">
              <br/>
            </div>
          </div>

          <!-- Descripciones -->
          <div class="igs-l4 igs-color7">
            <div class="row igs-fs-11 igs-left igs-pad-4">
              <div class="col-md-1">&nbsp;</div>
              <div class="col-md-2">Descripción Corta</div>
              <div class="col-md-6"><input type="text" v-model="rRCB.b011" size="16" /></div>
              <div class="col-md-3">
                Activa
                <select name="rRCB.b014">
                  <option value="S">Sí</option>
                  <option value="N">No</option>
                </select>
              </div>
            </div>

            <div class="row igs-fs-11 igs-left igs-pad-4">
              <div class="col-md-1">&nbsp;</div>
              <div class="col-md-2 igs-v-center">Descripción Mediana</div>
              <div class="col-md-9"><input type="text" v-model="rRCB.b012" size="32" /></div>
            </div>

            <div class="row igs-fs-11 igs-left igs-pad-4">
              <div class="col-md-1">&nbsp;</div>
              <div class="col-md-2">Comentarios</div>
              <div class="col-md-9"><input type="text" v-model="rRCB.b013" size="76" /></div>
            </div>

            <div><hr/></div>

          <!-- Rangos de Ubicaciones y Otros Parámetros -->
          <div class="row igs-fs-11 igs-left igs-pad-4">
              <div class="col-md-12">
                <h6 class="igs-center">Rango de Ubicaciones</h6>
                <table class="igs-fs-12" style="width:98%" border="0">
                  <tr>
                    <td width="20%">&nbsp;</td>
                    <td>&nbsp;</td>
                    <td align="center">Desde<br/>Ubicación</td>
                    <td align="center">Hasta<br/>Ubicación</td>
                    <td width="20%">&nbsp;</td>
                  </tr>
                  <tr>
                    <td width="20%">&nbsp;</td>
                    <td>Demarcación</td>
                    <td align="center"><input type="text" v-model="rRCB.u101" size="3" /></td>
                    <td align="center"><input type="text" v-model="rRCB.u201" size="3" /></td>
                    <td width="20%">&nbsp;</td>
                  </tr>
                  <tr>
                    <td width="20%">&nbsp;</td>
                    <td>Pasillo</td>
                    <td align="center"><input type="text" v-model="rRCB.u102" size="3" @change="lp60ActualizarValoresPasillo()"/></td>
                    <td align="center"><input type="text" v-model="rRCB.u202" size="3" /></td>
                    <td width="20%">&nbsp;</td>
                  </tr>
                  <tr>
                    <td width="20%">&nbsp;</td>
                    <td>Calle</td>
                    <td align="center"><input type="text" v-model="rRCB.u103" size="3" /></td>
                    <td align="center"><input type="text" v-model="rRCB.u203" size="3" /></td>
                    <td width="20%">&nbsp;</td>
                  </tr>
                  <tr>
                    <td width="20%">&nbsp;</td>
                    <td>Hueco</td>
                    <td align="center"><input type="text" v-model="rRCB.u104" size="3" /></td>
                    <td align="center"><input type="text" v-model="rRCB.u204" size="3" /></td>
                    <td width="20%">&nbsp;</td>
                  </tr>
                  <tr>
                    <td width="20%">&nbsp;</td>
                    <td>Altura / Estantería</td>
                    <td align="center"><input type="text" v-model="rRCB.u105" size="3" /></td>
                    <td align="center"><input type="text" v-model="rRCB.u205" size="3" /></td>
                    <td width="20%">&nbsp;</td>
                  </tr>
                  <tr>
                    <td width="20%">&nbsp;</td>
                    <td>Fila</td>
                    <td align="center"><input type="text" v-model="rRCB.u106" size="3" /></td>
                    <td align="center"><input type="text" v-model="rRCB.u206" size="3" /></td>
                    <td width="20%">&nbsp;</td>
                  </tr>
                </table>

                <br/>

              </div>
            </div>

            <hr/>

          </div>

          <br/>

        </div>
      </VModal>


  </div>
</template>

<script>
import igs_mixin from '@/igs-mixins/igs_mixin'
import TNC10000  from '@/igs-navegacion/TNC10000'
import BNC10000  from '@/igs-navegacion/BNC10000'
import axios     from 'axios';

//-- Rango de Fechas
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

//-- Iconos
import Fa from 'vue-fa'
import { faCheck, faClipboardCheck, faPlusSquare, faTrash, faSave, faWindowClose } from '@fortawesome/free-solid-svg-icons'


export default {
  mixins:       [ igs_mixin ],
  components :  { TNC10000, BNC10000, Fa, DateRangePicker },

  //----------------------------
  //-- Datos Locales
  //----------------------------
  data() {
    //-- Valores Predeterminado
    let startDate = new Date();
    let endDate   = new Date();
    startDate.setDate(endDate.getDate() - 30);

    let today = new Date()
    today.setHours(0, 0, 0, 0)

    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0);

    var thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    var thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999);

    return {
        //------------------------------------------------------------------------
        //-- Iconos
        //------------------------------------------------------------------------
        faCheck, faClipboardCheck, faPlusSquare, faTrash, faSave, faWindowClose,

       //------------------------------------------------------------------------
       //-- Variables Locales
       //------------------------------------------------------------------------

       //-- Lista de Tareas de Recuento disponibles
       laTareasRecuentoDisponibles : [],          

       //-- Registros Individuales de la Tarea de Recuento Activa (TRA)
       laRegistrosTRA : [],

       ltTareaRecuentoSeleccionada : '',          //-- Tarea de Recuento Actual

       ltFechaCreacionTareaActual : '00000000',
       ltHoraCreacionTareaActual : '000000',
       ltUsuarioCreacionTareaActual : '',

       ltFechaCierreTareaActual : '00000000',
       ltHoraCierreTareaActual : '000000',
       ltUsuarioCierreTareaActual : '',

       ltFiltroDesdeFecha   : '00000000',         //-- Desde Fecha (Inicio Tarea Recuento)
       ltFiltroHastaFecha   : '99999999',         //-- Hasta Fecha (Inicio Tarea Recuento)
       ltFiltroDiferencias  : '0',                //-- Filtro basado en Diferencias               (0-Todos, 1-Con Diferencias, 2-Sin Diferencias)   
       ltFiltroRecuento     : '0',                //-- Filtro basado en Ubicaciones               (0-Todas, 1-Recontadas, 2-Sin Recontar)   
       ltFiltroOcupacion    : '0',                //-- Filtro basado en Ocupación de la Ubicación (0-Todas, 1-Ocupadas, 2-Libres)   

       lnColumnaOrden : 0,                        //-- Índice de la Columna por la cual Ordenar los Resultados
       lbOrdenAscendente : true,                  //-- Ordenar los Resultados de forma ASCENDENTE (S/N)

       lbCargando : false,                        //-- Cargando Datos 

       rRCB : { b011:'', b012:'', b013:'', b014:'S', u101:'01', u102:'', u103:'00', u104:'00', u105:'00', u106:'00', u201:'01', u202:'', u203:'99', u204:'99', u205:'99', u206:'99' },                                 //-- Registro Tarea de Recuento

       dp1_dateRange: {startDate, endDate},
       dp1_localeData : {
          direction: 'ltr',
          format: 'dd-mm-yyyy',
          separator: ' a ',
          applyLabel: 'Confirmar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          customRangeLabel: 'Rango',
          daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
          monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          firstDay: 1
       },
       dp1_defaultRanges : {
          'Hoy': [today, today],
          'Ayer': [yesterday, yesterday],
          'Mes Actual': [thisMonthStart, thisMonthEnd],
          'Mes Anterior': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
          'Año Actual': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)]
       },

       ltDescripcionTareaActual : '',             //-- Descripción Tarea Seleccionada
       ltFechaRecuentoTareaActual : '00000000'    //-- Fecha de la Tarea de Recuento Seleccionada
        
    }
              

  },

  //----------------------------
  //-- Métodos Locales
  //----------------------------
  methods: {

      //............................................................................................
      //-- Conversión (Date) en (String) de la Fecha Inicial y Final para el Detalle de Movimientos
      //............................................................................................
      lp30RangoFechasDetalleMovimientos() {
          //-- Extraer Fecha INICIAL
          let startDate    = this.dp1_dateRange.startDate;
          let fechaInicial = this.f92Date2DTZ(startDate).substr(0,10).replace(/-/g,'');

          let endDate      = this.dp1_dateRange.endDate;
          let fechaFinal   = this.f92Date2DTZ(endDate).substr(0,10).replace(/-/g,'');

          //-- Retornar el valor calculado
          //console.log(' fechaInicial = ('+fechaInicial+') // fechaFinal = ('+fechaFinal+')');

          this.ltFiltroDesdeFecha   = fechaInicial;
          this.ltFiltroHastaFecha   = fechaFinal;

          //-- Recalcular la Lista de Tareas de Recuento disponibles
          this.lp98LeerTareasRecuentoDisponibles();
      },


      //----------------------------------------------------------------------
      //-- Ordenar Resultados (por el ÍNDICE de la COLUMNA indicada)
      //----------------------------------------------------------------------
      lp50Sort(indice) {
        //console.log(' lp50Sort ('+indice+')');

        //-- Misma Columna --> Conmutar Orden Ascendente/Descendente
        if (indice == this.lnColumnaOrden) {
          this.lbOrdenAscendente  = !this.lbOrdenAscendente;
        } else {
          //-- Actualizar Columna y Orden
          this.lnColumnaOrden     = indice;
          this.lbOrdenAscendente  = true;
        }

        //-- Ordenar Resultados
        this.lp60OrdenarResultados();

      },

      //------------------------------------------------------------------------
      //-- Actualizar valores relacionados con el cambio del Pasillo INICIAL
      //------------------------------------------------------------------------
      lp60ActualizarValoresPasillo() {

        //-- Actualizar HASTA Pasillo
        this.rRCB.u202 = this.rRCB.u102;

        //-- Actualizar DESCRIPCIONES
        this.rRCB.b011 = 'Pasillo '+this.rRCB.u102;
        this.rRCB.b012 = 'Pasillo '+this.rRCB.u102;

      },

      //-----------------------------------------------------------------
      //-- Al cambiar de Tarea de Recuento
      //-----------------------------------------------------------------
      lp60CambioTareaRecuento() {
        //console.log('--> Cambio de Tarea de Recuento');

        let item = this.laTareasRecuentoDisponibles.filter((obj) => ((obj.tcl0 == this.ltTareaRecuentoSeleccionada)));

        if ((item != null) && (item[0])) {

          //-- Actualizar Rótulos
          this.ltDescripcionTareaActual       = item[0].t012;
          this.ltFechaRecuentoTareaActual     = item[0].t036;

        } else {

          //-- Inicializar Rótulos
          this.ltDescripcionTareaActual       = '';
          this.ltFechaRecuentoTareaActual     = '00000000';

        }

        //-- Lectura Detalle de la Tarea de Recuento Activa
        this.lp98LeerTareaRecuentoActiva();
        
      },

      //----------------------------------------------------------------------
      //-- Creación de Nuevo Registro RCB
      //----------------------------------------------------------------------
      lp60CrearNuevaTareaRecuento() {
        //-- Mostrar Ventana de Edición Registro UXA
        this.$modal.show('VMLeyenda1');
      },   


      //----------------------------------------------------------------------
      //-- Ordenar los MOVIMIENTOS por el criterio seleccionado
      //----------------------------------------------------------------------
      lp60OrdenarResultados() {

        //-- Crear nueva lista con el Orden seleccionado
        let self = this;
        let listaOrdenada = this.laRegistrosTRA.sort(function(a, b){
          var nameA = '';
          var nameB = '';

          //-- Ubicación + Artículo
          if (self.lnColumnaOrden == 0) {
              nameA=a.t081+a.t002;
              nameB=b.t081+b.t002;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Artículo
          if (self.lnColumnaOrden == 1) {
              nameA=a.t002+a.t081;
              nameB=b.t002+b.t081;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Lote
          if (self.lnColumnaOrden == 2) {
              nameA=a.t003+a.t002;
              nameB=b.t003+b.t002;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Caducidad
          if (self.lnColumnaOrden == 3) {
              nameA=a.t031+a.t002;
              nameB=b.t031+b.t002;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Cantidad Teórica
          if (self.lnColumnaOrden == 4) {
              nameA=a.t511;
              nameB=b.t511;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Unidades Teóricas
          if (self.lnColumnaOrden == 5) {
              nameA=a.t512;
              nameB=b.t512;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Cantidad Real
          if (self.lnColumnaOrden == 6) {
              nameA=a.t521;
              nameB=b.t521;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Unidades Reales
          if (self.lnColumnaOrden == 7) {
              nameA=a.t522;
              nameB=b.t522;

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Diferencia Cantidades
          if (self.lnColumnaOrden == 8) {
              nameA=Math.abs(a.t531);
              nameB=Math.abs(b.t531);

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Diferencia Unidades
          if (self.lnColumnaOrden == 9) {
              nameA=Math.abs(a.t532);
              nameB=Math.abs(b.t532);

              if ((nameA < nameB) && self.lbOrdenAscendente)  { return -1; }
              if ((nameA > nameB) && self.lbOrdenAscendente)  { return  1; }

              if ((nameA < nameB) && !self.lbOrdenAscendente) { return  1; }
              if ((nameA > nameB) && !self.lbOrdenAscendente) { return -1; }

              return 0; 
          }

          //-- Resto de Casos
          return 0;
        });

        //-- Reemplazar Lista de Resultados                                              
        this.laRegistrosTRA = listaOrdenada;

      },


      //................................................................
      //-- Clase para aplicar en las DIFERENCIAS
      //................................................................
      lf91ClaseDiferencia(cantidad,unidades) {

        //-- Sin Diferencias : Nada que destacar
        if ((cantidad == 0) && (unidades == 0)) { return ''; } 

        //-- Con Diferencias : Resaltar
        let clase = 'igs-bold igs-l4';

        if ((cantidad > 0) || (unidades > 0)) {
          clase += ' igs-color9';
        } else {
          clase += ' igs-color8';
        }

        //-- Retornar Clase COMPLETA
        return clase;
      },

      //................................................................
      //-- Caracter para representar el ESTADO de la TAREA DE RECUENTO
      //................................................................
      lf95EstadoTarea(estado) {

        let caracter = '&#x2753;&nbsp;';       //-- En curso (Recontando)

        if (estado == 1)  { caracter = '&#x2705;&nbsp;'           }  //-- (✅︎)  (Cerrada)
        if (estado == 2)  { caracter = '&#x1f02b;&nbsp;'          }  //-- (🀫)  (Revisada)
        if (estado == 3)  { caracter = '&#x2757;&nbsp;'           }  //-- (❗︎)  (En Revisión)
        if (estado == 4)  { caracter = '&#x2b55;&nbsp;'           }  //-- (⭕︎)  (Recontado)
        if (estado == 5)  { caracter = '&#x1f58d;&nbsp;'          }  //-- (🖍)  (En Curso)
        if (estado == 6)  { caracter = '&#x2795;&nbsp;'           }  //-- (➕︎)  (Disponible - Sin Empezar)
        if (estado == 9)  { caracter = '&#x1f512;&#xfe0e;&nbsp;'  }  //-- (🔒︎)  (Bloqueada  - Sin Empezar)
                
        //-- Retornar el Estado
        return caracter;
      },

      //----------------------------------------------------------------------
      //-- Indicador de Columna y Orden aplicado
      //----------------------------------------------------------------------
      lf91ColumnaOrden(indice) {

        //-- Inicializar Resultado
        let textoHTML = '';

        //-- Aplicar Texto HTML ÚNICAMENTE sobre la columna por la cual está siendo ordenado el resultado
        if (indice == this.lnColumnaOrden) {
          if (this.lbOrdenAscendente) {
            textoHTML = '&nbsp;&nbsp;<i class="fa-solid fa-sort-up"/>';
          } else {
            textoHTML = '&nbsp;&nbsp;<i class="fa-solid fa-sort-down"/>';
          }
        }

        //-- Retornar Resultado
        return textoHTML;

      },

      //----------------------------------------------------------------------
      //-- Maquetación de la FECHA DE CADUCIDAD
      //----------------------------------------------------------------------
      lf91FechaCaducidad(fecha) {

        //-- Valor "vacío" (cuando NO se recibe valor alguno)
        if ((fecha == '') || (fecha == '00000000')) {
          return '';
        }

        //-- Fecha Maquetada
        return this.f70AMD2fDMA(fecha);

      },

      //----------------------------------------------------------------------
      //-- Comprobar que se trata de un NÚMERO 
      //-- (y NO contiene caracteres "extra", como GUIONES, PUNTOS, ...)
      //----------------------------------------------------------------------
      lf88isNumeric(value) {
       return /^\d+$/.test(value);
      },

      //----------------------------------------------------------------------
      //-- Desinencia de Tareas DUPLICADAS
      //----------------------------------------------------------------------
      lf90DesinenciaRCB(codigo) {

        //-- Codigos INFERIORES a 8 caracteres : Nada que informar
        if (codigo.length < 8) { return ''; }

        //-- Determinar el valor de la (Desinencia)
        let desinencia = codigo.substr(6,2);

        //-- Desinencia NUMÉRICA : Nada que informar
        if ((desinencia >= '00') && (desinencia <= '99')) { return ''; }

        //-- Mostrar la DESINENCIA ALFANUMÉRICA (entre paréntesis)
        return '(' + desinencia + ')';

      },

      //----------------------------------------------------------------------
      //-- Creacion de una Tarea de Recuento
      //----------------------------------------------------------------------
      lp98CrearNuevaTareaRecuento() {

        //.................................
        //-- Comprobaciones Previas
        //.................................

        //== Demarcación
        if ((this.rRCB.u101.length < 2) || (this.rRCB.u201.length < 2)) {
          this.p99AnuncioIA1('3','7','Aviso','La DEMARCACIÓN debe ser cubierta con 2 CIFRAS', 10);
          return;
        }

        if ((this.rRCB.u101 != this.rRCB.u201)) {
          this.p99AnuncioIA1('3','7','Aviso','La DEMARCACIÓN INICIAL y FINAL deben ser COINCIDENTES', 10);
          return;
        }

        if ((!this.lf88isNumeric(this.rRCB.u101)) || (!this.lf88isNumeric(this.rRCB.u201)) ) {
          this.p99AnuncioIA1('3','7','Aviso','La DEMARCACIÓN debe ser NUMÉRICA', 10);
          return;
        }

        //== Pasillo
        if (this.rRCB.u102.length < 2) {
          this.p99AnuncioIA1('3','7','Aviso','El PASILLO INICIAL debe ser cubierto con 2 CIFRAS', 10);
          return;
        }

        if (this.rRCB.u202.length < 2) {
          this.p99AnuncioIA1('3','7','Aviso','El PASILLO FINAL debe ser cubierto con 2 CIFRAS', 10);
          return;
        }

        if ((this.rRCB.u102 != this.rRCB.u202)) {
          this.p99AnuncioIA1('3','7','Aviso','El PASILLO INICIAL y FINAL deben COINCIDIR', 10);
          return;
        }

        if ((!this.lf88isNumeric(this.rRCB.u102)) || (!this.lf88isNumeric(this.rRCB.u202)) ) {
          this.p99AnuncioIA1('3','7','Aviso','Los PASILLOS deben ser NUMÉRICOS', 10);
          return;
        }

        //== Calle
        if ((this.rRCB.u103.length < 2) || (this.rRCB.u203.length < 2)) {
          this.p99AnuncioIA1('3','7','Aviso','La CALLE debe ser cubierta con 2 CIFRAS', 10);
          return;
        }

        if ((this.rRCB.u103 > this.rRCB.u203)) {
          this.p99AnuncioIA1('3','7','Aviso','La CALLE INICIAL debe ser INFERIOR ó IGUAL a la CALLE FINAL', 10);
          return;
        }

        if ((!this.lf88isNumeric(this.rRCB.u103)) || (!this.lf88isNumeric(this.rRCB.u203)) ) {
          this.p99AnuncioIA1('3','7','Aviso','Las CALLES deben ser NUMÉRICAS', 10);
          return;
        }

        //== Hueco
        if ((this.rRCB.u104.length < 2) || (this.rRCB.u204.length < 2)) {
          this.p99AnuncioIA1('3','7','Aviso','El HUECO debe ser cubierto con 2 CIFRAS', 10);
          return;
        }

        if ((this.rRCB.u104 > this.rRCB.u204)) {
          this.p99AnuncioIA1('3','7','Aviso','El HUECO INICIAL debe ser INFERIOR ó IGUAL al HUECO FINAL', 10);
          return;
        }

        if ((!this.lf88isNumeric(this.rRCB.u104)) || (!this.lf88isNumeric(this.rRCB.u204)) ) {
          this.p99AnuncioIA1('3','7','Aviso','Los HUECOS deben ser NUMÉRICOS', 10);
          return;
        }

        //== Altura
        if ((this.rRCB.u105.length < 2) || (this.rRCB.u205.length < 2)) {
          this.p99AnuncioIA1('3','7','Aviso','La ALTURA debe ser cubierta con 2 CIFRAS', 10);
          return;
        }

        if ((this.rRCB.u105 > this.rRCB.u205)) {
          this.p99AnuncioIA1('3','7','Aviso','La ALTURA INICIAL debe ser INFERIOR ó IGUAL a la ALTURA FINAL', 10);
          return;
        }

        if ((!this.lf88isNumeric(this.rRCB.u105)) || (!this.lf88isNumeric(this.rRCB.u205)) ) {
          this.p99AnuncioIA1('3','7','Aviso','Las ALTURAS deben ser NUMÉRICAS', 10);
          return;
        }

        //== Fila
        if ((this.rRCB.u106.length < 2) || (this.rRCB.u206.length < 2)) {
          this.p99AnuncioIA1('3','7','Aviso','La FILA debe ser cubierta con 2 CIFRAS', 10);
          return;
        }

        if ((this.rRCB.u106 > this.rRCB.u206)) {
          this.p99AnuncioIA1('3','7','Aviso','La FILA INICIAL debe ser INFERIOR ó IGUAL a la FILA FINAL', 10);
          return;
        }

        if ((!this.lf88isNumeric(this.rRCB.u106)) || (!this.lf88isNumeric(this.rRCB.u206)) ) {
          this.p99AnuncioIA1('3','7','Aviso','Las FILAS deben ser NUMÉRICAS', 10);
          return;
        }

        //-- Descripciones
        if ((this.rRCB.b011 == '') || (this.rRCB.b012 == '')) {
          this.p99AnuncioIA1('3','7','Aviso','Ambas DESCRIPCIONES deben ser cubiertas', 10);
          return;
        }

        //----------------------------------------------
        //-- Determinar los Parámetros para el ALTA
        //----------------------------------------------
        //-- Determinar el USUARIO activo
        let ltUsuario = this.$store.state.strMailUsuario.substring(0, this.$store.state.strMailUsuario.indexOf("@"));

        //-- Concatenar TODOS los Parámetros
        let ltParametros = this.rRCB.u101 + '^' + this.rRCB.u102 + '^' + this.rRCB.u103 + '^' + this.rRCB.u104 + '^' + this.rRCB.u105 + '^' + this.rRCB.u106 + '^' +
                           this.rRCB.u201 + '^' + this.rRCB.u202 + '^' + this.rRCB.u203 + '^' + this.rRCB.u204 + '^' + this.rRCB.u205 + '^' + this.rRCB.u206 + '^' + 
                           this.rRCB.b014 + '^' + this.rRCB.b011 + '^' + this.rRCB.b012 + '^' + this.rRCB.b013 + '^' + ltUsuario; 

        //-- Solicitar el Borrado al Servidor
        var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&u="+this.$store.state.strUsuario+"&d="+this.$store.state.strDistribuidor+"&a="+this.$store.state.strAlmacen+"&t=200&m=491&x="+encodeURI(ltParametros);

        //-- Contactar con el Servidor del Distribuidor
        axios.get(URL, {responseEncoding: 'utf-8'})                         
        .then(respuesta => {

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si ha habido EXITO ó ERROR
            var flg = global.lnkGetDataError;
            if (datos.flg) {  flg = datos.flg; }

            //-- Actualizar Resultados
            this.p99Log(5,1,'-- Respuesta (200491) --');
            this.p99Log(5,2,datos);

            if (flg == global.lnkGetDataOk)  {

              //-- Ocultar Ventana Modal
              this.$modal.hide('VMLeyenda1');

              //-- Inicializar la Tarea de Recuento Seleccionada
              this.ltTareaRecuentoSeleccionada = '';

              //-- Releer la Lista de Recuentos
              this.lp98LeerTareasRecuentoDisponibles();

              //-- Informar Éxito
              this.p99AnuncioIA1('1','7','ÉXITO', 'Nueva Tarea CREADA con ÉXITO', 5);

              //-- Mensaje de Éxito
              this.p99Log(5,1,' **** EXITO ****');

            } else {
              //-- Informar el Error
              this.p99Log(1,1,' #### ERROR (200491) ####');
              if (datos.msg) { this.p99AnuncioIA1('2','7','ERROR', datos.msg,-1); } else { this.p99AnuncioIA1('2','7','ERROR', respuesta.data,-1); }
            }
        })
        .catch(error => {
            //-- Mostrar el Mensaje de Error oportuno
            this.p99Log(1,1,'** ERROR **');
            this.p99Log(1,1,error);
        });        

      },  

      //----------------------------------------------------------------------
      //-- Borrado de una Tarea de Recuento
      //----------------------------------------------------------------------
      lp98BorrarTareaRecuento() {

        //-- Impedir BORRADO de Tareas de Recuento YA CERRADAS
        if (this.ltFechaCierreTareaActual != '00000000') {
          this.p99AnuncioIA1('3','7','Aviso','No se permite BORRAR las Tareas de Recuento ya CERRADAS', 10);
          return;
        }

        //-- Solicitar el Borrado al Servidor
        var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&u="+this.$store.state.strUsuario+"&d="+this.$store.state.strDistribuidor+"&a="+this.$store.state.strAlmacen+"&t=200&m=493&x="+encodeURI(this.ltTareaRecuentoSeleccionada);

        //-- Contactar con el Servidor del Distribuidor
        axios.get(URL, {responseEncoding: 'utf-8'})                         
        .then(respuesta => {

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si ha habido EXITO ó ERROR
            var flg = global.lnkGetDataError;
            if (datos.flg) {  flg = datos.flg; }

            //-- Actualizar Resultados
            this.p99Log(5,1,'-- Respuesta (200493) --');
            this.p99Log(5,2,datos);

            if (flg == global.lnkGetDataOk)  {

              //-- Inicializar la Tarea de Recuento Seleccionada
              this.ltTareaRecuentoSeleccionada = '';

              //-- Releer la Lista de Recuentos
              this.lp98LeerTareasRecuentoDisponibles();

              //-- Informar Éxito
              this.p99AnuncioIA1('1','7','ÉXITO', 'Tarea BORRADA con ÉXITO', 10);

              //-- Mensaje de Éxito
              this.p99Log(5,1,' **** EXITO ****');

            } else {
              //-- Informar el Error
              this.p99Log(1,1,' #### ERROR (200493) ####');
              if (datos.msg) { this.p99AnuncioIA1('2','7','ERROR', datos.msg,-1); } else { this.p99AnuncioIA1('2','7','ERROR', respuesta.data,-1); }
            }
        })
        .catch(error => {
            //-- Mostrar el Mensaje de Error oportuno
            this.p99Log(1,1,'** ERROR **');
            this.p99Log(1,1,error);
        });        

      },   

      //----------------------------------------------------------------------
      //-- Cierre de la TAREA DE RECUENTO activa
      //----------------------------------------------------------------------
      lp98CerrarTareaRecuentoActiva() {

        this.p99Log(5,1,' (lp98CerrarTareaRecuentoActiva)');

        //-- Solicitar Confirmación
        if (confirm("¿ Estás SEGURO de CERRAR el Recuento del ["+this.ltDescripcionTareaActual+"] ?")) {

          //-- Determinar el USUARIO activo
          let ltUsuario = this.$store.state.strMailUsuario.substring(0, this.$store.state.strMailUsuario.indexOf("@"));

          //-- Llamada al Servidor
          var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&u="+this.$store.state.strUsuario+"&d="+this.$store.state.strDistribuidor+"&a="+this.$store.state.strAlmacen+"&t=200&m=451&x="+encodeURI(this.ltTareaRecuentoSeleccionada+'^'+ltUsuario);

          this.p99Log(1,1,' (lp98CerrarTareaRecuentoActiva) URL = '+URL);

          //-- Contactar con el Servidor del Distribuidor
          axios.get(URL, {responseEncoding: 'utf-8'})                         
          .then(respuesta => {

              //-- Extraer la respuesta recibida
              var datos = respuesta.data;

              //-- Determinar si ha habido EXITO ó ERROR
              var flg = global.lnkGetDataError;
              if (datos.flg) {  flg = datos.flg; }

              //-- Actualizar Resultados
              this.p99Log(5,1,'-- Respuesta (200451) --');
              this.p99Log(5,2,datos);

              if (flg == global.lnkGetDataOk)  {

                //-- Releer la Lista de Recuentos
                this.lp98LeerTareasRecuentoDisponibles();

                //-- ReLeer la Tarea de Recuento
                this.lp98LeerTareaRecuentoActiva();

                //-- Mostrar Mensaje de Éxito
                this.p99AnuncioIA1('1','7',global.lnkAppName, "La Tarea de Recuento ha sido CERRADA con éxito",-1);

                //-- Mensaje de Éxito
                this.p99Log(5,1,' **** EXITO ****');

              } else {
                //-- Informar el Error
                this.p99Log(1,1,' #### ERROR (200451) ####');
                if (datos.msg) { this.p99AnuncioIA1('2','7','ERROR', datos.msg,-1); } else { this.p99AnuncioIA1('2','7','ERROR', respuesta.data,-1); }
              }
          })
          .catch(error => {
              //-- Mostrar el Mensaje de Error oportuno
              this.p99Log(1,1,'** ERROR **');
              this.p99Log(1,1,error);
          });

        }

      },     

      //----------------------------------------------------------------------
      //-- Lectura de la Relación de TAREAS DE RECUENTO disponibles
      //----------------------------------------------------------------------
      lp98LeerTareasRecuentoDisponibles() {
        this.p99Log(5,1,' (lp98LeerTareasRecuentoDisponibles)');

        //-- Llamada al Servidor
        let parametros = this.ltFiltroDesdeFecha + '^' + this.ltFiltroHastaFecha;
        var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&u="+this.$store.state.strUsuario+"&d="+this.$store.state.strDistribuidor+"&a="+this.$store.state.strAlmacen+"&t=200&m=411&x="+encodeURI(parametros);

        this.p99Log(1,1,' (lp98LeerTareasRecuentoDisponibles) URL = '+URL);

        //-- Contactar con el Servidor del Distribuidor
        axios.get(URL, {responseEncoding: 'utf-8'})                         
        .then(respuesta => {

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si ha habido EXITO ó ERROR
            var flg = global.lnkGetDataError;
            if (datos.flg) {  flg = datos.flg; }

            //-- Actualizar Resultados
            this.p99Log(5,1,'-- Respuesta (200411) --');
            this.p99Log(5,2,datos);

            if (flg == global.lnkGetDataOk)  {

              //-- Reemplazar Lista de Fechas y Rutas con Carga Viva
              this.laTareasRecuentoDisponibles = datos.t200m411;

              //-- Mensaje de Éxito
              this.p99Log(5,1,' **** EXITO ****');

            } else {
              //-- Informar el Error
              this.p99Log(1,1,' #### ERROR (200411) ####');
              if (datos.msg) { this.p99AnuncioIA1('2','7','ERROR', datos.msg,-1); } else { this.p99AnuncioIA1('2','7','ERROR', respuesta.data,-1); }
            }
        })
        .catch(error => {
            //-- Mostrar el Mensaje de Error oportuno
            this.p99Log(1,1,'** ERROR **');
            this.p99Log(1,1,error);
        });

      },

      //----------------------------------------------------------------------
      //-- Lectura de una TAREA DE RECUENTO ACTIVA (TRA)
      //----------------------------------------------------------------------
      lp98LeerTareaRecuentoActiva() {
        this.p99Log(5,1,' (lp98LeerTareaRecuentoActiva)');

        //-- Llamada al Servidor
        var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&u="+this.$store.state.strUsuario+"&d="+this.$store.state.strDistribuidor+"&a="+this.$store.state.strAlmacen+"&t=200&m=421&x="+encodeURI(this.ltTareaRecuentoSeleccionada);

        this.p99Log(1,1,' (lp98LeerTareaRecuentoActiva) URL = '+URL);

        //-- Contactar con el Servidor del Distribuidor
        axios.get(URL, {responseEncoding: 'utf-8'})                         
        .then(respuesta => {

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si ha habido EXITO ó ERROR
            var flg = global.lnkGetDataError;
            if (datos.flg) {  flg = datos.flg; }

            //-- Actualizar Resultados
            this.p99Log(5,1,'-- Respuesta (200421) --');
            this.p99Log(5,2,datos);

            if (flg == global.lnkGetDataOk)  {

              //-- Reemplazar Detalle de la Tarea Actual
              this.laRegistrosTRA = datos.t200m421;

              //-- Otros Atributos
              this.ltFechaCreacionTareaActual     = datos.b041;
              this.ltHoraCreacionTareaActual      = datos.b042;
              this.ltUsuarioCreacionTareaActual   = datos.b043;

              this.ltFechaCierreTareaActual       = datos.b071;
              this.ltHoraCierreTareaActual        = datos.b072;
              this.ltUsuarioCierreTareaActual     = datos.b073;

              //-- Ordenar Resultados
              this.lp60OrdenarResultados();

              //-- Mensaje de Éxito
              this.p99Log(5,1,' **** EXITO ****');

            } else {
              //-- Informar el Error
              this.p99Log(1,1,' #### ERROR (200421) ####');
              if (datos.msg) { this.p99AnuncioIA1('2','7','ERROR', datos.msg,-1); } else { this.p99AnuncioIA1('2','7','ERROR', respuesta.data,-1); }
            }
        })
        .catch(error => {
            //-- Mostrar el Mensaje de Error oportuno
            this.p99Log(1,1,'** ERROR **');
            this.p99Log(1,1,error);
        });

      },
      
      //----------------------------------------------------------------------
      //-- Antes de OCULTAR la Leyenda .1.
      //----------------------------------------------------------------------
      lp99OcultandoLeyenda1() {
        this.p99Log(5,1,' >>> Ocultando la Leyenda .1.');
      }
      

  },

  /**************************************************************/
  /****************       Filtros / Formatos     ****************/
  /**************************************************************/
  filters: {
      //..............................................
      //--- Filtro para dar FORMATO a las FECHAS
      //..............................................
      lf60FiltroFecha: function (date) {

          let dw = date.toLocaleDateString('es-ES', { weekday: 'long' });
          dw = dw.charAt(0).toUpperCase() + dw.slice(1);

          //-- Fecha
          const d = date.getDate();
          const m = date.getMonth() + 1;
          //const y = date.getFullYear();
          const y = date.getFullYear();

          //-- Hora
          //const hora = date.getHours();
          //const minutos = date.getMinutes();

          //return dw + ' ' + (d < 10 ? '0' : '') + d + '-' + (m < 10 ? '0' : '') + m + '-' + y + ' ' + (hora < 10 ? '0' : '') + hora + ':' + (minutos < 10 ? '0' : '') + minutos;
          return dw + ' ' + (d < 10 ? '0' : '') + d + '-' + (m < 10 ? '0' : '') + m + '-' + y;
      }
  },

  //----------------------------
  //-- Datos Calculados
  //----------------------------
  computed: {

      //----------------------------------------------------------------------
      //-- Lista de Registros de Detalle a Mostrar (Filtrada)
      //----------------------------------------------------------------------
      lf50ListaRegistrosTRA() {

        let listaFiltrada = [];
        let i = 0;
        let reg   = null;
        let regOk = true;

        //-- Bucle de comprobación
        while (i<this.laRegistrosTRA.length) {

          //-- Puntero al registro a evaluar
          reg = this.laRegistrosTRA[i];
          regOk = true;

          //-- Comprobaciones
          //::: Diferencias (S/N)
          if ((this.ltFiltroDiferencias == '1') &&  (reg.t531 == 0) && (reg.t532 == 0))   { regOk = false; }
          if ((this.ltFiltroDiferencias == '2') && ((reg.t531 != 0) || (reg.t532 != 0)))  { regOk = false; }

          //::: Recontados (S/N)
          if ((this.ltFiltroRecuento == '1') &&  (reg.t521 == 0) && (reg.t522 == 0))      { regOk = false; }
          if ((this.ltFiltroRecuento == '2') && ((reg.t521 != 0) || (reg.t522 != 0)))     { regOk = false; }

          //::: Ocupación (S/N)
          if ((this.ltFiltroOcupacion == '1') &&  (reg.t002 == ''))                       { regOk = false; }
          if ((this.ltFiltroOcupacion == '2') &&  (reg.t002 != ''))                       { regOk = false; }

          //-- Agregar (si cumple TODOS los filtros)
          if (regOk) { listaFiltrada.push(reg)}

          //-- Siguiente
          i += 1;
        }

        //-- Retornar Lista Filtrada
        return listaFiltrada;
      },

      //----------------------------------------------------------------------
      //-- Número de ARTÍCULOS ÚNICOS Mostrados
      //----------------------------------------------------------------------
      lf91ArticulosMostrados() {
        const a = [...new Set(this.lf50ListaRegistrosTRA.map(item => item.t002))]; 
        return a.length;
      },

      //----------------------------------------------------------------------
      //-- Número de ARTÍCULOS ÚNICOS Recibidos
      //----------------------------------------------------------------------
      lf91ArticulosRecibidos() {
        const a = [...new Set(this.laRegistrosTRA.map(item => item.t002))]; 
        return a.length;
      },

      //----------------------------------------------------------------------
      //-- Número de UBICACIONES ÚNICAS Mostrados
      //----------------------------------------------------------------------
      lf91UbicacionesMostradas() {
        const a = [...new Set(this.lf50ListaRegistrosTRA.map(item => item.t081))]; 
        return a.length;
      },

      //----------------------------------------------------------------------
      //-- Número de UBICACIONES ÚNICAS Recibidos
      //----------------------------------------------------------------------
      lf91UbicacionesRecibidas() {
        const a = [...new Set(this.laRegistrosTRA.map(item => item.t081))]; 
        return a.length;
      },

      //----------------------------------------------------------------------
      //-- Acumulado NETO de las Diferencias
      //----------------------------------------------------------------------
      lf91SumaDiferencias() {
        return this.laRegistrosTRA.reduce((n, {t531}) => n + t531, 0);
      },

      //----------------------------------------------------------------------
      //-- Acumulado NETO de las Cantidades
      //----------------------------------------------------------------------
      lf91SumaCantidades() {
        return this.laRegistrosTRA.reduce((n, {t511}) => n + t511, 0);
      }

  },

  //----------------------------
  //-- Al cargar esta página
  //----------------------------
  mounted() {
      //-- Actualizar Módulo "Vivo"
      this.$store.commit('p10StrModuleName', 'SVC40000');


      //-- Actualizar BreadCrumb 
      this.$store.commit('p10StrMenuBC', [
        {
          text: "4. Recuentos",
          href: "#"
        }
      ]);

     //-- Replicar Desde/Hasta Fecha sobre los campos (texto) equivalentes
     this.lp30RangoFechasDetalleMovimientos();

     //-- Cargar la Lista de Tareas de Recuento 
     //this.lp98LeerTareasRecuentoDisponibles();

  }

}
</script>

<style lang="scss">
.nav-pills > a.active {
  background-color: $bc1 !important;
}  
</style>
